<template>
  <b-carousel
    ref="carousel"
    v-model="currentCarouselItem"
    :arrow="false"
    :pause-info="false"
    :pause-hover="false"
    :autoplay="false"
  >
    <b-carousel-item v-for="(carouselItem, i) in items" :key="i">
      <p v-html="carouselItem.text"></p>
      <div v-if="carouselItem.tipSrc" class="tip-ct content has-text-centered">
        <video :id="`tip-${i}`" loop playsinline muted>
          <source
            :src="`${publicPath}${carouselItem.tipSrc}`"
            type="video/mp4"
          />
        </video>
      </div>
      <div v-else>
        <p v-html="carouselItem.text"></p>
      </div>
    </b-carousel-item>
  </b-carousel>
</template>

<style scoped>
p {
  text-align: center;
}
div.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: stretch;
  overflow: auto;
}
video {
  width: 100%;
  height: 45vh;
  object-fit: contain;
}
</style>

<script>
import { ref, computed, watch, nextTick, onMounted } from 'vue'

export default {
  name: 'Carousel',
  emits: ['carousel-item-changed'],
  props: {
    items: {
      type: Array,
      default: () => []
    },
    currentItem: {
      type: Number,
      default: 0
    },
    publicPath: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const carousel = ref(null)
    const item = ref(0)

    const currentCarouselItem = computed({
      get() {
        return props.currentItem
      },
      set(val) {
        emit('carousel-item-changed', val)
      }
    })

    const handleVideoChange = (newIdx, oldIdx) => {
      console.log('next', newIdx, 'prev', oldIdx)
      nextTick(() => {
        if (oldIdx !== undefined) {
          let lastItem = carousel.value?.$el.querySelector(`#tip-${oldIdx}`)
          if (lastItem) {
            lastItem.pause()
            lastItem.currentTime = 0
          }
        }
        let nextItem = carousel.value?.$el.querySelector(`#tip-${newIdx}`)
        if (nextItem) {
          nextItem.play()
          nextItem.addEventListener('canplaythrough', () => nextItem.play())
        }
      })
    }

    // Play the first video when the component mounts
    onMounted(() => {
      handleVideoChange(props.currentItem)
    })

    const nextTip = () => {
      if (item.value < props.items.length - 1) {
        item.value++
        return
      }
      item.value = 0
    }

    const prevTip = () => {
      if (item.value > 0) {
        item.value--
        return
      }
      item.value = props.items.length - 1
    }

    watch(
      () => props.currentItem,
      (newIdx, oldIdx) => {
        handleVideoChange(newIdx, oldIdx)
      }
    )

    return {
      carousel,
      item,
      currentCarouselItem,
      handleVideoChange,
      nextTip,
      prevTip
    }
  }
}
</script>
